/**
 * maintenanceStore — global "service paused" flag.
 *
 * Toggled by useAsk / useVoice when an /ask or /voice request returns
 * HTTP 503 (the backend's maintenance middleware fires on 503 only
 * when MAINTENANCE_MODE=true is set in the Fly environment).
 *
 * While `isMaintenance` is true, the chat input is disabled and a
 * sticky banner appears at the top of the chat surface.  The flag
 * clears when:
 *   - the user dismisses the banner ("Try again" button), OR
 *   - the page reloads.
 *
 * We intentionally don't auto-poll /health to clear the flag.  Real
 * users opening the app during an outage see the banner from the
 * first request; once we lift the env var they refresh and resume.
 * Keeping the loop manual keeps the implementation small and avoids
 * background fetches that would themselves contribute to load.
 */

import { create } from "zustand";

interface MaintenanceState {
  isMaintenance: boolean;
  setMaintenance: (on: boolean) => void;
}

export const useMaintenanceStore = create<MaintenanceState>((set) => ({
  isMaintenance: false,
  setMaintenance: (on: boolean) => set({ isMaintenance: on }),
}));
